/**
 * Tools Category Nodes
 * Nodes that provide tool capabilities and integrations
 */

import mcpTool from './mcp-tool';
import mcpUiRenderer from './mcp-ui-renderer';
import braveSearch from './brave-search';
import executeWorkflowTool from './execute-workflow-tool';

export default {
  'mcp-tool': mcpTool,
  'mcp-ui-renderer': mcpUiRenderer,
  'brave-search': braveSearch,
  'execute-workflow-tool': executeWorkflowTool
};
